export default __webpack_public_path__ + "static/media/lubbers-logo-white.0c82150b.svg";